"use client";

import { Button } from "@/components/buttons/Button";
import { ButtonProps } from "@/components/buttons/types";
import { useSetAuthModalOpen } from "@/lib/clerk/useSetAuthModalOpen";

export function SignInButton({
  className,
  variant,
}: {
  className?: string;
  variant?: ButtonProps["variant"];
}) {
  const setAuthModalOpen = useSetAuthModalOpen();

  return (
    <Button onClick={setAuthModalOpen} variant={variant} className={className}>
      Sign in
    </Button>
  );
}
